import _ from 'underscore'

export const getGMAPAddressComponents = (addressComponents) => {
    if (!addressComponents) return null
    const result = {}
    addressComponents.forEach((entry) => {
        if (_.contains(entry.types, 'locality')) result.locality = entry.long_name
        if (_.contains(entry.types, 'postal_code')) result.zip = entry.long_name
        if (_.contains(entry.types, 'street_number')) result.streetNumber = entry.long_name
        if (_.contains(entry.types, 'route')) result.street = entry.long_name
        if (_.contains(entry.types, 'country') && entry.short_name) result.country = entry.short_name.toLowerCase()
    })
    return result
}

export const formatAddress = (data) => {
    if (!data.street) return ''
    let address = data.street
    if (data.streetNumber)
        address += ` ${data.streetNumber}`
    if (data.locality || data.zip)  
        address += ', '
    if (data.locality)
        address += `${data.locality} ` 
    if (data.zip)
        address += data.zip 
    return address
}


// WEBPACK FOOTER //
// ./src/common/helpers.js